module.exports = __webpack_public_path__ + "img/cross-selling-banner-tutorial.97badf1.png";